export default 'Faire voter des travaux énergétiques en AG : préparation amont, majorités, 1re et 2e convocation. Méthode Solution Éco France pour sécuriser le vote.';
